import axios from 'axios'
import router from '../router'
import { config } from '../constant/config'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: config.BASE_URL, // api的base_url
  timeout: 180 * 1000 // 请求超时时间 90秒，因为微信支付的需要等等按密码时间所以时间设置的很长
})

// request拦截器
service.interceptors.request.use(config => {
  if (sessionStorage.getItem('token')) {
    config.headers.token = sessionStorage.getItem('token')
  }
  return config
}, error => {
  console.warn('请求异常' + JSON.stringify(error))
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.status !== 200 && res.status !== 200) {
      alert(res.message)
    } else {
      if (res.code === 1017 && response.config.url.indexOf('/pc/user/login') >= 0) {
        Message({
          message: res.error || res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        // router.push({
        //   path: '/'
        // })
      } else {
        return response.data
      }
    }
  },
  error => {
    console.warn('响应异常' + JSON.stringify(error))
    if (error.code === 'ECONNABORTED') {
      alert(error.message)
    } else {
      return Promise.reject(error)
    }
  }
)
export default service
